module.exports = __webpack_public_path__ + "static/about-us-20-30d42da49278db051218ffc7f56009d1.jpg";